export const VERSION = 'version 1.3.0.';

// ลิงก์ Add LINE ผ่าน me-qr เพื่อให้การตลาดนับจำนวนคนกดได้ — แก้ที่นี่ที่เดียว
export const LINE_ADD_FRIEND_URL = 'https://q.me-qr.com/kmge52gv';
export const LINE_FOOTER_ICON_URL = 'https://q.me-qr.com/4d232rf3';
export const MARGINTOP20 = {
  marginTop: '20px'
}

export const GUTTER_LAYOUT = {
  MAIN_CONTENT: [16, 16],
  SUB_COUTENT: [8, 8],
  OTHER_COUTENT: [24, 24],
}

export const BREAKE_POINT = {
  MAIN_CONTENT: {
    xs: 24,
    sm: 24,
    md: 12,
    lg: 12,
    xl: 12
  },
  SUB_CONTENT: {
    xs: 24,
    sm: 24,
    md: 24,
    lg: 24,
    xl: 24
  },
  OTHER_COUTENT_ONE: {
    xs: 24,
    sm: 24,
    md: 8,
    lg: 8,
    xl: 8
  },
  OTHER_COUTENT_TWO: {
    xs: 24,
    sm: 12,
    md: 12,
    lg: 12,
    xl: 12
  },
  OTHER_COUTENT_THREE :{
    xs: 12,
    sm: 12,
    md: 12,
    lg: 12,
    xl: 12
  },
  OTHER_COUTENT_FOUR :{
    xs: 24,
    sm: 24,
    md: 12,
    lg: 10,
    xl: 10
  },
  OTHER_COUTENT_FIVE :{
    xs: 24,
    sm: 24,
    md: 12,
    lg: 14,
    xl: 14
  },
  OTHER_COUTENT_SIX :{
    xs: 12,
    sm: 12,
    md: 12,
    lg: 12,
    xl: 12
  },
  OTHER_COUTENT_SEVEN :{
    xs: 12,
    sm: 8,
    md: 8,
    lg: 8,
    xl: 8
  }
}


